import { render, staticRenderFns } from "./validation-modal.vue?vue&type=template&id=0da15a6e&"
import script from "./validation-modal.vue?vue&type=script&lang=js&"
export * from "./validation-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports